import React, { useEffect } from "react";

const Mouse = () => {
  // Les [] évitent que l'effet se joue à l'infini
  useEffect(() => {
    const cursor = document.querySelector(".cursor");
    // console.log(cursor);
    // window est nul part en react, donc on utilise du javascript et non du react. Au lieu de "on click" dans les balises par exemple, on utilise l'ajout d'événement de type addEventListener
    // Au mousemove, je récupère l'événement
    window.addEventListener("mousemove", (e) => {
      cursor.style.top = e.y + "px";
      cursor.style.left = e.x + "px";
    });
    // Pour l'effet de réduction du cercle, je sélectionne tous les élément ayant la classe hover et chacun, je les nomme "link" et je leur applique la logique suivante
    // Quand je survole un élément cliquable, tu me sors la classe "hovered"

    document.querySelectorAll(".hover").forEach((link) => {
      link.addEventListener("mouseover", () => {
        cursor.classList.add("hovered");
      });

      //   Je dois retirer l'effet après le survol pour un retour du cercle à sa dimension initiale
      link.addEventListener("mouseleave", () => {
        cursor.style.transition = ".3s ease-out";
        cursor.classList.remove("hovered");
      });
    });
  }, []);

  return <span className="cursor"></span>;
};

export default Mouse;
